import { FormProvider } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { CheckIcon } from "@heroicons/react/16/solid";
import { AvailabilityList } from "./availability-list";

export const AvailabilityForm = ({
    methods,
    onSubmit,
    daysOfWeek,
    isPending,
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="col-span-full grid flex-1 grid-cols-subgrid"
            >
                <AvailabilityList daysOfWeek={daysOfWeek} />
                <div className="mt-auto">
                    <Button
                        type="submit"
                        variant="primary"
                        className="mt-4"
                        disabled={isPending}
                    >
                        <CheckIcon />
                        {isPending ? "Saving" : "Save schedule"}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
